import styled from 'styled-components'
import { mix } from 'polished';

export const FooterStyles = styled('footer') <{
	colorMain: string
	colorBackground: string
	colorBorder: string
}>`
	position: fixed;
	bottom: 0px;
	left: 0px;
	width: 100%;
	padding: 0 10px 10px 10px;
	box-sizing: border-box;
	background-color: ${props => props.colorBackground};

	div {
		border-top: 1px solid ${props => props.colorBorder};
	}

	@media (min-width: 1024px) {
		position: inherit;
		bottom: 0px;
		left: 0px;
		width: 100%;
		padding: 0;
		box-sizing: border-box;
		background-color: ${props => props.colorBackground};
	}
`

export const OtpConfirmationWrapper = styled.div<{
	colorMain: string
	colorBackground: string
	colorBorder: string
}>`
  	text-align: left;
	
	.btn-back {
		font-size: 12px;
		cursor: pointer;
		width: fit-content;
	}

	h4 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 4px;
	}

	p {
		font-size: 12px;
		margin-bottom: 20px;
	}

	.otp-wrapper {
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		width: 100%;

		.otp-input {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 12px;
			margin-bottom: 10px;
			width: 100%;
			max-width: 500px;
			margin: 0 auto;

			.group {
				display: flex;
				border: 1px solid #CFCFCF;
				border-radius: 4px;
				background-color: ${props => props.colorBackground};
				flex: 1 1 0;

				.otp-box {
					flex: 1 1 0;
					min-width: 0;
					text-align: center;
					font-size: 24px;
					aspect-ratio: 1;
					width: 100%;
					height: auto;
					border: none;
					border-left: 1px solid #CFCFCF;
					background-color: ${props => props.colorBackground};
					appearance: none;
					-webkit-appearance: none;
					border-radius: 0;

					&:first-child {
						border-left: none;
					}

					&:focus {
						outline: none;
						background-color: rgba(0, 0, 0, 0.05);
					}

					&:disabled {
						background-color: #f3f4f6;
						cursor: not-allowed;
					}

				}
			}

			.dash-line {
				width: 16px;
				height: 1px;
				background-color: #6b7280;
			}
		}

		.otp-timer {
			font-size: 12px;
			margin-left: 6px;
		}
	}

	.otp-actions {
		font-size: 12px;
		margin-bottom: 24px;

		a {
			color: ${props => props.colorMain};
			text-decoration: underline;
			cursor: pointer;

			&.disabled {
				cursor: not-allowed;
				color: #ccc;
				pointer-events: none;
			}
		}
	}

	.centered {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 15px;
	}

	.toggle-method {
		border: 1px solid ${props => props.colorMain};
		background-color: transparent;
		color: ${props => props.colorMain};
		padding: 8px 12px;
		cursor: pointer;

		border-radius: 4px;
		font-size: 14px;
		margin-bottom: 10px;
		transition: background-color 0.2s, color 0.2s, border-color 0.2s;

		&:hover {
			background-color: ${props => props.colorMain};
			color: white;
		}

		&:active {
			background-color: ${props => props.colorMain};
			color: white;
			opacity: 0.8;
		}

		&:focus,
		&:focus-visible {
			outline: none;
			box-shadow: none;
		}

		&:disabled {
			background-color: #e0e0e0;
			color: #aaa;
			border-color: #ccc;
			cursor: not-allowed;
			opacity: 0.6;
			pointer-events: none;
		}
	}
`
